import cookie_ from 'js-cookie'
import { getEndpointBase } from '#app/lib/api/endpoint'
import { LogError } from '#app/lib/loggers'
import preq from '#app/lib/preq'
import { parseBooleanString } from '#app/lib/utils'
import { commands } from '#app/radio'
import type { OwnerSafeUser } from '#server/controllers/user/lib/authorized_user_data_pickers'
import { initI18n } from './i18n'
import { solveLang } from './solve_lang'

const apiUser = getEndpointBase('user')
// the cookie is deleted on logout
export const loggedIn = parseBooleanString(cookie_.get('loggedIn'))

export const mainUser: OwnerSafeUser = await getMainUser()

async function getMainUser () {
  if (loggedIn) {
    try {
      const user = await preq.get(apiUser)
      // Strictly speaking, user should be typed as (OwnerSafeUser | DeletedUser), but the deleted user case is sorted out with this logout
      if (user.type === 'deleted') commands.execute('logout')
      return user as OwnerSafeUser
    } catch (err) {
    // Known to happen with vite in dev mode
    // Typically with: "ReferenceError: can't access lexical declaration 'shortLang' before initialization"
      if (err.name === 'ReferenceError') {
        commands.execute('show:error', err)
        console.error('error at main user initialization: reloading', err)
        location.reload()
      } else {
      // Known cases of session errors:
      // - when the server secret is changed
      // - when the current session user was deleted but the cookies weren't removed
      //   (possibly because the deletion was done from another browser or even another device)
        console.error('resetSession', err)
        commands.execute('logout', '/login')
      }
    }
  }
}

export const waitForI18n = initI18n(solveLang(mainUser?.language)).catch(LogError('i18n initialize error'))

export async function deleteMainUserAccount () {
  await preq.delete(apiUser)
  commands.execute('logout')
}
